var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "ruleForm",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { staticClass: "upload-method", attrs: { label: "模式选择" } },
            [
              _c(
                "el-select",
                {
                  on: { change: _vm.changeMethod },
                  model: {
                    value: _vm.inputMethod,
                    callback: function ($$v) {
                      _vm.inputMethod = $$v
                    },
                    expression: "inputMethod",
                  },
                },
                _vm._l(_vm.methods, function (m) {
                  return _c("el-option", {
                    key: m.value,
                    attrs: { label: m.label, value: m.value },
                  })
                }),
                1
              ),
              _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "故事生成方式" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择方式" },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "问答形式-保险", value: "qa" },
                  }),
                  _c("el-option", {
                    attrs: { label: "问答形式-通用", value: "common" },
                  }),
                  _c("el-option", {
                    attrs: { label: "条款形式", value: "term" },
                  }),
                  _c("el-option", {
                    attrs: { label: "文本形式", value: "text" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.inputMethod === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "保险公司" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择保险公司" },
                      model: {
                        value: _vm.form.company,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "company", $$v)
                        },
                        expression: "form.company",
                      },
                    },
                    _vm._l(_vm.companyList, function (c) {
                      return _c("el-option", {
                        key: c.id,
                        attrs: { label: c.name, value: c.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.inputMethod === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "PDF样式" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.pdfStyle,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pdfStyle", $$v)
                        },
                        expression: "form.pdfStyle",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "竖模式", value: "column" },
                      }),
                      _c("el-option", {
                        attrs: { label: "横模式", value: "row" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.inputMethod === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "知识库的选择", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "value-key": "id",
                        clearable: true,
                        placeholder: "请选择文件",
                      },
                      on: { clear: _vm.clearFile, change: _vm.changeFile },
                      model: {
                        value: _vm.form.file,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "file", $$v)
                        },
                        expression: "form.file",
                      },
                    },
                    _vm._l(_vm.fileOptions, function (o) {
                      return _c("el-option", {
                        key: o.id,
                        attrs: { label: o.name, value: o },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.inputMethod === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "文件上传", required: "" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "left",
                      attrs: {
                        action: "#",
                        "auto-upload": false,
                        "on-remove": _vm.handleRemove,
                        "on-change": _vm.handleChange,
                        "file-list": _vm.fileList,
                        accept: "file",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [
                              _vm._v(
                                " 点击上传(支持markdown,条款pdf和excel三种格式) "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "width50",
              attrs: { label: "知识名称", required: "" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入知识名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "width100", attrs: { label: "知识描述" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入知识描述" },
                model: {
                  value: _vm.form.desc,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "desc", $$v)
                  },
                  expression: "form.desc",
                },
              }),
            ],
            1
          ),
          _vm.inputMethod === 0
            ? _c(
                "el-form-item",
                {
                  staticClass: "width100 height100 content",
                  attrs: { label: "知识内容", required: "" },
                },
                [
                  _c("el-button", { on: { click: _vm.addContent } }, [
                    _vm._v("新增"),
                  ]),
                  _vm._l(_vm.form.content, function (text, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "center" },
                      [
                        _c("el-input", {
                          attrs: {
                            id: `textarea${index}`,
                            maxlength: "3000",
                            "show-word-limit": "",
                            type: "textarea",
                            placeholder: "请输入知识内容",
                          },
                          on: {
                            input: function ($event) {
                              _vm.textareaId = `textarea${index}`
                            },
                          },
                          model: {
                            value: _vm.form.content[index],
                            callback: function ($$v) {
                              _vm.$set(_vm.form.content, index, $$v)
                            },
                            expression: "form.content[index]",
                          },
                        }),
                        index !== 0
                          ? _c("i", {
                              staticClass: "el-icon-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.delContent(index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.inputMethod === 1 || _vm.inputMethod === 2
            ? _c(
                "el-form-item",
                {
                  staticClass: "width100 height100 content",
                  attrs: { label: "知识内容", required: "" },
                },
                [
                  _vm.form.content[0]
                    ? _vm._l(_vm.form.content, function (text, index) {
                        return _c("v-md-preview", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.uploadLoading,
                              expression: "uploadLoading",
                            },
                          ],
                          key: index,
                          attrs: { text: text },
                        })
                      })
                    : [
                        _c("el-input", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.uploadLoading,
                              expression: "uploadLoading",
                            },
                          ],
                          attrs: {
                            readonly: "",
                            maxlength: "3000",
                            "show-word-limit": "",
                            type: "textarea",
                            placeholder: "请选择文件进行转换",
                          },
                        }),
                      ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }